<template>
  <div class="input__wrap">
    <select
    class="form-control"
    :id="keyName"
    :name="keyName"
    v-model="inputValue"
    @change="$emit('change', $event.target.value)"
    >
      <option
      v-for="option in array"
      :key="option.id"
      :value="option.value">{{ option.label }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  props: {
    keyName: {
      type: String,
      required: true,
    },
    array: {
      type: Array,
      required: true,
    },
    selectValue: {
      type: String,
      required: true,
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.selectValue
      },
      // set() {}
    }
  }
}
</script>

<style lang="scss" scoped>
.input__wrap {
  border-bottom: 2px solid $main_color;
  // padding-bottom: 5px;
  width: 100%;
  box-sizing: border-box;
  select {
    border: none;
  }
}
</style>